/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CenterStatSalaryDto } from '../../models/center-stat-salary-dto';

export interface CenterStatControllerGetSalaryStat$Params {
  year: string;
  centerId: string;
}

export function centerStatControllerGetSalaryStat(http: HttpClient, rootUrl: string, params: CenterStatControllerGetSalaryStat$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<CenterStatSalaryDto>>> {
  const rb = new RequestBuilder(rootUrl, centerStatControllerGetSalaryStat.PATH, 'get');
  if (params) {
    rb.query('year', params.year, {});
    rb.query('centerId', params.centerId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<CenterStatSalaryDto>>;
    })
  );
}

centerStatControllerGetSalaryStat.PATH = '/api/center-stat/salary';
